import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, Input, message, Select, InputNumber, Row, Col, Tooltip } from 'antd';
import AxiosOICStat from '../../AxiosOICStat';
import { Switch } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { setIndicator, setIndicators } from '../../features/indicatorsSlice';
import FormulaBuilder from '../FormulaBuilder';
import "../../style/App.scss"

let isFetch = true;

export const setFetch = (newValue) => {
    isFetch = newValue;
};

export const getFetch = () => isFetch;

export const IndicatorEditModal = ({ visible, record, onCancel, onEdit, editable, isAddMode }) => {
    const [form] = Form.useForm();
    const [indicatorData, setIndicatorData] = useState({});
    const [initialSecondaryCategories, setInitialSecondaryCategories] = useState([]);
    const [secondaryCategories, setSecondaryCategories] = useState([]);
    const [baseIndicator, setBaseIndicator] = useState(undefined);
    const [weightIndicator, setWeightIndicator] = useState(undefined);
    const [aggregationType, setAggregationType] = useState('');
    const [formulaPreview, setFormulaPreview] = useState('');
    const [customFormulaString, setCustomFormulaString] = useState('');
    const unitsState = useSelector((state) => state.units);
    const categoriesState = useSelector((state) => state.categories);
    const sourcesState = useSelector((state) => state.sources);
    const indicatorsState = useSelector((state) => state.indicators);
    const dispatch = useDispatch();


    const fetchData = () => {
        // Example fetch function
        AxiosOICStat.get('indicators/details')
            .then(response => {
                const indicators = {};
                response.data.forEach(indicator => {
                    indicators[indicator.ind_code] = indicator;
                });
                dispatch(setIndicators(indicators));
            })
            .catch(err => {
                console.error('Error fetching data:', err);
            });
    };
    

    useEffect(() => {
        if (!visible) return;

        if (isAddMode) {
            form.resetFields();
            setIndicatorData({});
            setInitialSecondaryCategories([]);
            setSecondaryCategories([]);
            setCustomFormulaString('');
        } else if (record && record.ind_code) {
            setBaseIndicator(undefined);
            setWeightIndicator(undefined);
            setAggregationType('');
            setFormulaPreview('');
            setCustomFormulaString('');

            AxiosOICStat.get(`indicators/${record.ind_code}`)
                .then(response => {
                    setIndicatorData(response.data);
                    form.setFieldsValue(response.data);
                    
                    if (response.data.formula) {
                        setCustomFormulaString(response.data.formula);
                    }
                    
                    if (response.data.aggr_formula) {
                        const parts = response.data.aggr_formula.split(',').map(p => p.trim());
                        if (parts.length > 0) {
                            const base = parts[0].startsWith('ind') ? parts[0].substring(3) : null;
                            if (base) setBaseIndicator(`${base} - ${indicatorsState.value[base]?.ind_name_eng || ''}`);
                        }
                        if (parts.length > 1) {
                            const weight = parts[1].startsWith('ind') ? parts[1].substring(3) : null;
                            if (weight) setWeightIndicator(`${weight} - ${indicatorsState.value[weight]?.ind_name_eng || ''}`);
                        }
                        setFormulaPreview(response.data.aggr_formula || '');
                    }
                    if (response.data.aggr_method) {
                        setAggregationType(response.data.aggr_method);
                    }
                })
                .catch(err => {
                    console.log(err);
                });

            AxiosOICStat.get(`secondary-categories/${record.ind_code}`)
                .then(response => {
                    const categoryCodes = response.data.map(item => item.cat_code);
                    // add secondary categories to the indicator data and set the form fields
                    setSecondaryCategories(categoryCodes);
                    form.setFieldsValue({
                        secondaryCategories: categoryCodes,
                    });
                    setInitialSecondaryCategories(categoryCodes);
                })
                .catch(err => {
                    // set to empty array if no secondary categories
                    setIndicatorData(prevIndicatorData => {
                        return {
                            ...prevIndicatorData,
                            secondaryCategories: [],
                        };
                    }
                    );
                    form.setFieldsValue({
                        secondaryCategories: [],
                    });
                    console.log(err);
                });
        }
    }, [record, form, isAddMode, visible]);




    const handleEditSubmit = (values) => {
        const submittedValues = {
            ...values,
            formula: customFormulaString || null
        };
        
        if (isAddMode) {

            const { ...indicatorValues } = submittedValues;
            console.log(secondaryCategories, indicatorValues);

            AxiosOICStat.post(`indicators`, indicatorValues).then(response => {
                message.success('Indicator with code ' + response.data.ind_code + ' is added successfully');
                onEdit(response.data);
                handleCancel();

                secondaryCategories.forEach(cat => {
                    AxiosOICStat.post(`secondary-categories/`, { ind_code: response.data.ind_code, cat_code: cat });
                });
                dispatch(setIndicator(response.data));
                setFetch(true);
            }).catch(err => {
                message.error('Error adding indicator');
                handleCancel();
            });
        } else {
            const { ...indicatorValues } = submittedValues;

            const addedCategories = secondaryCategories.filter(cat => !initialSecondaryCategories.includes(cat));
            const removedCategories = initialSecondaryCategories.filter(cat => !secondaryCategories.includes(cat));


            if (indicatorValues.hasOwnProperty('aggr_method') && indicatorValues.aggr_method === '') {
                indicatorValues.aggr_method = null;
            }
            if (indicatorValues.hasOwnProperty('aggr_formula') && indicatorValues.aggr_formula === '') {
                indicatorValues.aggr_formula = null;
            }

            AxiosOICStat.put(`indicators/${record.ind_code}`, indicatorValues).then(response => {
                dispatch(setIndicator(response.data));
                addedCategories.forEach(cat => {
                    AxiosOICStat.post(`secondary-categories/`, { ind_code: record.ind_code, cat_code: cat });
                });

                // Handle removed categories
                removedCategories.forEach(cat => {
                    AxiosOICStat.delete(`secondary-categories/${record.ind_code}/${cat}`);
                });

                onEdit(response.data);

                handleCancel(1);
                dispatch(setIndicator(response.data));
                fetchData()
                
                setFetch(true);
            }).catch(err => {
                message.error('Error updating indicator');
            });
        }
    };

    const handleCancel = (code = -1) => {
        form.resetFields();
        setIndicatorData({});
        setInitialSecondaryCategories([]);
        setSecondaryCategories([]);
        setCustomFormulaString('');
        setBaseIndicator(undefined);
        setWeightIndicator(undefined);
        setAggregationType('');
        setFormulaPreview('');

        if (code === 1) {
            onCancel(1);
        } else {
            onCancel();
        }
    };

    const handleSecondaryCategoriesChange = (selectedItems) => {
        setSecondaryCategories(selectedItems);
    };

    const handleBaseIndicatorChange = (value) => {
        setBaseIndicator(value);
    };

    const handleWeightIndicatorChange = (value) => {
        setWeightIndicator(value);
    };

    const handleAggregationTypeChange = (value) => {
        setAggregationType(value);
    };

    const handleCustomFormulaChange = (formulaString) => {
        setCustomFormulaString(formulaString);
    };

    useEffect(() => {
        let formula = '';
        if (baseIndicator) {
            const baseCode = baseIndicator.split(' - ')[0];
            formula = `ind${baseCode}`;
        }
        if (weightIndicator) {
            const weightCode = weightIndicator.split(' - ')[0];
            formula = formula ? `${formula},ind${weightCode}` : `ind${weightCode}`;
        }
        setFormulaPreview(formula);

        const methodValue = aggregationType === 'None' ? null : (aggregationType || null);
        const formulaValue = aggregationType === 'None' ? null : (formula || null);

        form.setFieldsValue({ aggr_formula: formulaValue, aggr_method: methodValue });
    }, [baseIndicator, weightIndicator, aggregationType, form]);

    return (
        <Modal
            visible={visible}
            title={isAddMode ? "Add New Indicator" : (editable ? "Edit Indicator" : "Show Indicator")}
            onCancel={handleCancel}
            onOk={() => form.submit()}
            width="60%"
            footer={isAddMode || editable ? [
                <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                <Button key="submit" type="primary" onClick={() => form.submit()}>
                    {isAddMode ? "Add" : "Save"}
                </Button>,
            ] : [
                <Button key="close" onClick={handleCancel}>Close</Button>
            ]}
        >
            {indicatorData && (
                <Form
                    form={form}
                    onFinish={handleEditSubmit}
                    onCancel={handleCancel}
                    disabled={!editable}
                    labelCol={{ span: 6 }}
                    labelAlign='left'
                    wrapperCol={{ span: 18 }}
                >
                    <Form.Item label="Code" name="ind_code">
                        {isAddMode ? (
                            <p className="custom-input">Will be determined automatically</p>
                        ) : (
                            <InputNumber disabled className="custom-input" style={{ width: "100%" }} />
                        )}
                    </Form.Item>
                    <Form.Item label="Name" name="ind_name_eng" rules={[{ required: true, message: 'Indicator name is required' }]}>
                        <Input className="custom-input" />
                    </Form.Item>
                    <Form.Item label="SYB Name" name="syb_name">
                        <Input className="custom-input" />
                    </Form.Item>
                    <Row gutter={12}>
                        <Col span={18}>
                            <Form.Item label="Optional Name" name="optional_name" labelCol={{span: 8}}>
                                <Input className="custom-input" />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="Is Used" name="is_used" valuePropName="checked" >
                                <Switch className="custom-input" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item label="Explanation" name="ind_eng_exp">
                        <Input.TextArea autoSize={{ minRows: 1, maxRows: 4 }} className="custom-input" />
                    </Form.Item>
                    <Form.Item label="Primary Category Name - Code" name="cat_code" rules={[{ required: true, message: 'Primary category is required' }]}>
                        <Select showSearch autoClearSearchValue={false} optionFilterProp="children" className="custom-input">
                            {Object.values(categoriesState.value).map(category => (
                                <Select.Option key={category.cat_code} value={category.cat_code}>
                                    {category.cat_name_eng} - {category.cat_code}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Secondary Categories" name="secondaryCategories">
                        <Select
                            mode="multiple"
                            optionFilterProp="children"
                            placeholder="Select secondary categories"
                            showSearch
                            autoClearSearchValue={false}
                            value={secondaryCategories}
                            onChange={handleSecondaryCategoriesChange}
                            className="custom-input"
                        >
                            {Object.values(categoriesState.value).map(category => (
                                category.cat_code !== indicatorData.cat_code && (
                                    <Select.Option key={category.cat_code} value={category.cat_code}>
                                        {category.cat_name_eng} - {category.cat_code}
                                    </Select.Option>
                                )))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Unit Name - Code" name="unit_code" rules={[{ required: true, message: 'Unit is required' }]}>
                        <Select showSearch autoClearSearchValue={false} optionFilterProp="children" className="custom-input">
                            {Object.values(unitsState.value).map(unit => (
                                <Select.Option key={unit.unit_code} value={unit.unit_code}>
                                    {unit.unit_name_eng} - {unit.unit_code}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Source Name - Code" name="source_code">
                        <Select showSearch autoClearSearchValue={false} optionFilterProp="children" className="custom-input">
                            {Object.values(sourcesState.value).map(source => (
                                <Select.Option key={source.source_code} value={source.source_code}>
                                    {source.source_name_eng} - {source.source_code}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Name (French)" name="ind_name_fr">
                        <Input className="custom-input" />
                    </Form.Item>
                    <Form.Item label="Name (Arabic)" name="ind_name_arb">
                        <Input className="custom-input" />
                    </Form.Item>
                    <Form.Item label="Explanation (French)" name="ind_fr_exp">
                        <Input.TextArea autoSize={{ minRows: 1, maxRows: 4 }} className="custom-input" />
                    </Form.Item>
                    <Form.Item label="Explanation (Arabic)" name="ind_arb_exp">
                        <Input.TextArea autoSize={{ minRows: 1, maxRows: 4 }} className="custom-input" />
                    </Form.Item>
                    <Form.Item label="Is Private" name="is_private" valuePropName="checked">
                        <Switch className="custom-input" />
                    </Form.Item>
                    <Form.Item label="Aggregation Settings">
                        <div style={{ padding: 8, border: '1px dashed #d9d9d9', borderRadius: 4 }}>
                            <Row gutter={12} style={{ marginBottom: 8 }}>
                                <Col span={12}>
                                    <label style={{ display: 'block', marginBottom: 4 }}>Base Indicator</label>
                                    <Select
                                        showSearch
                                        autoClearSearchValue={false}
                                        placeholder="Select base indicator"
                                        value={baseIndicator}
                                        onChange={handleBaseIndicatorChange}
                                        style={{ width: '100%' }}
                                        allowClear
                                    >
                                        {Object.values(indicatorsState.value || {}).map(indicator => (
                                            <Select.Option key={indicator.ind_code} value={`${indicator.ind_code} - ${indicator.ind_name_eng}`}>
                                                <Tooltip title={`${indicator.ind_code} - ${indicator.ind_name_eng}`} placement="topLeft">
                                                    <span>{indicator.ind_code} - {indicator.ind_name_eng}</span>
                                                </Tooltip>
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Col>
                                <Col span={12}>
                                    <label style={{ display: 'block', marginBottom: 4 }}>Weighted Indicator (optional)</label>
                                    <Select
                                        showSearch
                                        autoClearSearchValue={false}
                                        placeholder="Select weight indicator"
                                        value={weightIndicator}
                                        onChange={handleWeightIndicatorChange}
                                        style={{ width: '100%' }}
                                        allowClear
                                    >
                                        {Object.values(indicatorsState.value || {}).map(indicator => (
                                            <Select.Option key={indicator.ind_code} value={`${indicator.ind_code} - ${indicator.ind_name_eng}`}>
                                                <Tooltip title={`${indicator.ind_code} - ${indicator.ind_name_eng}`} placement="topLeft">
                                                    <span>{indicator.ind_code} - {indicator.ind_name_eng}</span>
                                                </Tooltip>
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Col>
                            </Row>
                            <Row gutter={12} style={{ marginBottom: 8 }}>
                                <Col span={12}>
                                    <label style={{ display: 'block', marginBottom: 4 }}>Aggregation Type</label>
                                    <Select value={aggregationType || undefined} onChange={handleAggregationTypeChange} style={{ width: '100%' }} allowClear>
                                        <Select.Option value="Sum">Sum</Select.Option>
                                        <Select.Option value="Median">Median</Select.Option>
                                        <Select.Option value="Weighted Average">Weighted Average</Select.Option>
                                        <Select.Option value="Average">Average</Select.Option>
                                        <Select.Option value="None">None</Select.Option>
                                    </Select>
                                </Col>
                                <Col span={12}>
                                    <label style={{ display: 'block', marginBottom: 4 }}>Formula Preview</label>
                                    <Input value={formulaPreview} readOnly className="custom-input" />
                                </Col>
                            </Row>
                        </div>
                    </Form.Item>

                    <Form.Item label="Indicator Formula Builder">
                        <FormulaBuilder 
                            key={record?.ind_code || 'new'}
                            indicators={indicatorsState.value}
                            value={customFormulaString}
                            onChange={handleCustomFormulaChange}
                        />
                    </Form.Item>

                    <Form.Item name="aggr_method" style={{ display: 'none' }}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="aggr_formula" style={{ display: 'none' }}>
                        <Input />
                    </Form.Item>
                </Form>
            )}
        </Modal>
    );
};